<template>
  <div v-if="project.subprojects.length">
    <div
      v-for="(subproject, index) in project.subprojects"
      :key="subproject.id"
    >
      <h4 class="text-left">
        {{ $t("form.project.subproject") }} {{ index + 1 }}
      </h4>
      <v-row>
        <v-col cols="12">
          <v-tabs v-model="tab_title[subproject.id]" color="black">
            <v-tab
              class="capitalize"
              v-for="(item, index) in Object.keys(subproject.title)"
              :key="index"
            >
              {{ $t("form." + item) }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab_title[subproject.id]">
            <v-tab-item
              class="mt-2"
              v-for="(item, index) in Object.keys(subproject.title)"
              :key="index"
            >
              <v-text-field
                v-model="subproject.title[item]"
                :label="$t('form.title')"
                readonly
                filled
                outlined
              ></v-text-field>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
      <v-row v-if="Object.keys(subproject.description).length > 0">
        <v-col cols="12">
          <v-tabs v-model="tab_description[subproject.id]" color="black">
            <v-tab
              class="capitalize"
              v-for="(item, index) in Object.keys(subproject.description)"
              :key="index"
            >
              {{ $t("form." + item) }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab_description[subproject.id]">
            <v-tab-item
              class="mt-2"
              v-for="(item, index_descp) in Object.keys(subproject.description)"
              :key="index_descp"
            >
              <EditorText
                v-if="load_complete"
                :disabled="true"
                :key="item"
                :text="subproject.description[item]"
                :language="item"
                :subproject="index"
                field="description"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <v-textarea
            v-model="subproject.description[$i18n.locale]"
            :label="$t('form.description')"
            readonly
            filled
            outlined
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            :value="
              subproject.main_citius_investigators.map(
                p =>
                  p.preferred_name.given_name +
                  ' ' +
                  p.preferred_name.family_name
              )
            "
            :label="$t('form.project.main_citius_investigators')"
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="subproject.main_external_investigators"
            :label="$t('form.project.main_external_investigators')"
            readonly
            filled
            outlined
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            :value="
              subproject.citius_investigators.map(
                p =>
                  p.preferred_name.given_name +
                  ' ' +
                  p.preferred_name.family_name
              )
            "
            :label="$t('form.project.citius_investigators')"
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="subproject.external_investigators"
            :label="$t('form.project.external_investigators')"
            readonly
            filled
            outlined
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            :value="subproject.start_date"
            :label="$t('form.project.start_date')"
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="subproject.end_date"
            :label="$t('form.project.end_date')"
            readonly
            filled
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            :value="subproject.contractor != null ? subproject.contractor.name : ''"
            readonly
            :label="$t('form.project.contractor')"
            filled
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-divider />
    </div>
  </div>
  <div class="mt-8" v-else>
    <v-row class="justify-center">
      <v-col cols="12" md="6">
        <v-alert dense text type="info">
          {{ $t("project.no.subprojects") }}
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import project_data from "../../mixins/project_data";
import EditorText from "../reusables/EditorText";
export default {
  name: "DetailSubprojects",
  components: {EditorText},
  props: {
    project_id: Number
  },

  data() {
    return {
      tab_title: {},
      tab_description: {}
    };
  },
  mixins: [project_data],
  created() {
    this.getProject(
      this.$store.state.endpoint + "/user/project/" + this.project_id
    );
    this.project.subprojects.forEach(subproject => {
      this.tab_title.append(subproject.id, 0);
      this.tab_description.append(subproject.id, 0);
    });
  }
};
</script>

<style scoped></style>
